namespace advisorop.components.common {

    export class UploadFileProperties {
        constructor(props: {
            name: string,
            documentDate: Date,
            documentDescription: string,
            lastModified: number,
            attachment: boolean,
            attachDocumentId: number,
            attachDocumentVersion: number,
            accountId: number,
            accountNumber: string,
            meetingId: number,
            meetingGuid: string,
            investorId: number,
            investorName: string,
            advisoryFirmId: number,
            showUploadToCustodianCheckbox: boolean,
            file: File
        }) {
            
            this.name = props.name;
            this.documentDescription = props.documentDescription;
            this.attachment = props.attachment;
            this.attachDocumentId = props.attachDocumentId;
            this.attachDocumentVersion = props.attachDocumentVersion;
            this.accountId = props.accountId;
            this.accountNumber = (props.accountNumber == undefined ? (props.accountId > 0 ? "<no account number>" : "Select an account.") : props.accountNumber);
            this.investorId = props.investorId;
            this.investorName = (props.investorName == undefined ? "Select an investor." : props.investorName);
            this.advisoryFirmId = props.advisoryFirmId;
            this.documentDate = props.documentDate;
            this.lastModified = props.lastModified;
            this.sendToCustodian = false;
            this.file = props.file;
            this.showUploadToCustodianCheckbox = props.showUploadToCustodianCheckbox;
            this.progress = 0;
            this.documentTypeValue = null;
            this.externalSystemValue = null;
            this.meetingId = props.meetingId;
            this.meetingGuid = props.meetingGuid;
        };

        name: string;
        documentDate: Date;
        documentDescription: string;
        lastModified: number;
        attachment: boolean;
        attachDocumentId: number;
        attachDocumentVersion: number;
        accountId: number;
        accountNumber: string;
        meetingId: number;
        meetingGuid: string;
        investorId: number;
        investorName: string;
        advisoryFirmId: number;
        documentTypeValue: number;
        externalSystemValue: number;
        sendToCustodian: boolean;
        file: File;
        showUploadToCustodianCheckbox: boolean;
        progress: number;

        set accountSearchResult(value: domains.ISearchAccountResults) {
            if (value == null)
                return;
            this.accountId = value.accountId;
            this.accountNumber = value.accountDescription;

            this.showUploadToCustodianCheckbox = value.investmentType == domains.InvestmentType.CUSTODIAN_ACCOUNT;
            this.sendToCustodian = this.showUploadToCustodianCheckbox ? this.sendToCustodian : false;
        };

        set investorSearchResult(value: domains.ISearchInvestorHouseholdResults) {
            if (value == null)
                return;
            this.investorId = value.id;
            this.investorName = value.name;
        }

        public formFieldValue(key: string) {
            switch (key) {
                case "headerString": {
                    return "";
                }
                case "documentDate": {
                    return this.documentDate.toISOString().slice(0, 10);
                }
                case "file": {
                    return this.file;
                }
                case "documentTypeValue": {
                    return this.documentTypeValue.toString();
                }
                case "sendToCustodian": {
                    return this.sendToCustodian ? "1" : "0";
                }
                case "externalSystemValue": {
                    return this.externalSystemValue.toString();
                }
                default: {
                    return this[key].toString();
                }
            }
        }

        fileUploadProgress(e) {
            //console.log(`FileUploadProgress: ${e.type}`);
            if (e.lengthComputable) {
                let progressBarId = 'pro' + this.name + this.lastModified;
                document.getElementById(progressBarId).setAttribute('value', e.loaded);
                document.getElementById(progressBarId).setAttribute('max', e.total);
            }
        }
    }

    class FileUploaderController {
        // bindings
        attachment: boolean;
        attachDocumentId: number;
        attachDocumentVersion: number;
        accountId: number;
        accountNumber: string;
        accountDocuments: boolean;
        investor: domains.IInvestor;
        investorId: number;
        investorName: string;
        investorDocuments: boolean;
        operationsDataFiles: boolean;
        meetingId: number;
        meetingGuid: string;
        meetingDocuments: boolean;
        onAllFilesUploaded: any;
        meetingDocumentTypeValue: number = 1500; // As defined in AdvOpEnums.cs enum DocumentType
        loadEndEvent: any;
        advisoryFirmId: number;
        advisoryFirmDocuments: boolean;
        accountDocumentAttachments: boolean = false;
        investorDocumentAttachments: boolean = false;
        allDocumentTypes: domains.ILOV[] = [];
        documentTypes: domains.ILOV[] = [];
        externalSystems: domains.IExternalSystem[];

        uploadEnabled: boolean = false;
        showUploadToCustodianCheckbox: boolean = false;

        accountDocumentUploadUrl = '/api/advisor/uploadaccountdocument';
        investorDocumentUploadUrl = '/api/advisor/uploadinvestordocument';
        advisoryFirmDocumentUploadUrl = '/api/servicer/uploadadvisoryfirmdocument';
        accountAttachmentUploadUrl = '/api/advisor/attachaccountdocument';
        investorAttachmentUploadUrl = '/api/advisor/attachinvestordocument';
        operationsDataFileUploadUrl = '/api/servicer/importoperationsdatafile';
        meetingFileUploadUrl = 'api/meetinghub/uploaddocuments'

        uploadFileProperties: UploadFileProperties[] = [];
        currentUploadFileProperty: UploadFileProperties;
        accountSearchResults: domains.ISearchAccountResults = {};
        investorSearchResults: domains.ISearchInvestorHouseholdResults = {};
        dgDocumentsToUploadOptions: DevExpress.ui.dxDataGridOptions;
        dgDocumentsToUpload: DevExpress.ui.dxDataGrid;
        dxUploadButtonOptions: DevExpress.ui.dxButtonOptions;
        dxUploadToCustodianCheckboxOptions: DevExpress.ui.dxCheckBoxOptions;

        showSearch = false;
        puSearchOptions: DevExpress.ui.dxPopupOptions;
        searchTitle: string;
        uploadButtonText: string;
        uploadingLadda: boolean = false;

        static $inject = ["generalService", "$scope"];
        constructor(
            private generalService: advisorop.services.GeneralService,
            private $scope: ng.IScope
        ) {
            this.dgDocumentsToUploadOptions = {
                bindingOptions: {
                    dataSource: "vm.uploadFileProperties"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "No Documents",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                wordWrapEnabled: true,
                columns: [
                    { caption: "File Name", allowEditing: false, cellTemplate: "fileNameCell" },
                    { dataField: "documentDescription", caption: "Description", allowEditing: true, visible: false },
                    {
                        dataField: "accountNumber", caption: "Account", editCellTemplate: (cellElement, cellInfo) => {
                            this.searchPopup(cellElement, cellInfo);
                        },
                        visible: false,
                        allowEditing: false
                    },
                    {
                        dataField: "investorName", caption: "Investor", editCellTemplate: (cellElement, cellInfo) => {
                            this.searchPopup(cellElement, cellInfo);
                        },
                        visible: false,
                        allowEditing: false
                    },
                    { dataField: "documentDate", caption: "Last Modified", dataType: "date" },
                    { dataField: "documentTypeValue", caption: "Document Type", width: 300 },
                    { dataField: "externalSystemValue", caption: "External System", width: 200 },
                    { caption: "Send to Custodian", dataType: "boolean", cellTemplate: "uploadToCustodian", visible: false }
                ],
                editing: {
                    mode: "cell",
                    allowUpdating: true,
                    allowDeleting: true,
                },
                onRowRemoved: (e) => {
                    this.enableUploadButton();
                },
                onRowUpdated: (e) => {
                    this.enableUploadButton();
                },
                onInitialized: (obj) => {
                    this.dgDocumentsToUpload = obj.component;
                    this.setupColumns();
                }
            }

            this.puSearchOptions = {
                deferRendering: false,
                width: 400,
                height: 300,
                contentTemplate: "searchPopup",
                showTitle: true,
                dragEnabled: false,
                closeOnOutsideClick: true,
                bindingOptions: {
                    visible: "vm.showSearch",
                    title: "vm.searchTitle"
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Save",
                            onClick: () => {
                                this.SaveSearch();
                            }
                        }
                    },
                    {
                        widget: "dxButton",
                        location: "after",
                        toolbar: "bottom",
                        options: {
                            text: "Cancel",
                            onClick: () => {
                                this.CancelSearch();
                            }
                        }
                    }
                ]
            }

            //this.dxUploadButtonOptions = {
            //    bindingOptions: {
            //        disabled: "!vm.uploadEnabled",
            //        text: "vm.uploadButtonText"
            //    },
            //    onClick: () => {
            //        this.uploadFiles();
            //    }
            //}

            this.dxUploadToCustodianCheckboxOptions = {
                bindingOptions: {
                    disabled: "!doc.data.showUploadToCustodianCheckbox",
                    value: "doc.data.sendToCustodian"
                }
            }
        }

        setupColumns() {
            if (this.dgDocumentsToUpload) {
                if (this.attachment == true) {
                    this.dgDocumentsToUpload.columnOption("Document Type", "visible", false);
                    this.dgDocumentsToUpload.columnOption("Account", "visible", false);
                    this.dgDocumentsToUpload.columnOption("Account", "allowEditing", false);
                    this.dgDocumentsToUpload.columnOption("Send to Custodian", "visible", false);
                    this.dgDocumentsToUpload.columnOption("Investor", "visible", false);
                    this.dgDocumentsToUpload.columnOption("Investor", "allowEditing", false);
                    this.dgDocumentsToUpload.columnOption("External System", "visible", false);
                    this.uploadButtonText = "Attach Files";
                } else {
                    this.dgDocumentsToUpload.columnOption("Document Type", "visible", this.meetingDocuments ? false : true);
                    this.dgDocumentsToUpload.columnOption("Description", "visible", this.meetingDocuments);
                    this.dgDocumentsToUpload.columnOption("Account", "visible", this.accountDocuments);
                    this.dgDocumentsToUpload.columnOption("Account", "allowEditing", (this.accountId == undefined));
                    this.dgDocumentsToUpload.columnOption("Send to Custodian", "visible", this.accountDocuments);
                    this.dgDocumentsToUpload.columnOption("Investor", "visible", this.investorDocuments);
                    this.dgDocumentsToUpload.columnOption("Investor", "allowEditing", (this.investor == undefined));
                    this.dgDocumentsToUpload.columnOption("External System", "visible", this.operationsDataFiles);
                    this.uploadButtonText = "Upload Files";
                }
            }
        }

        searchPopup(cellElement: any, cellInfo: any) {
            this.currentUploadFileProperty = cellInfo.data;
            this.showSearch = true;
        };

        SaveSearch() {
            if (this.accountDocuments) {
                this.currentUploadFileProperty.accountSearchResult = this.accountSearchResults;
            } else {
                this.currentUploadFileProperty.investorSearchResult = this.investorSearchResults;
            }
            this.CancelSearch();
        }

        CancelSearch() {
            this.showSearch = false;
            this.enableUploadButton();
        }

        enableUploadButton() {
            if (this.uploadFileProperties.length == 0) {
                this.uploadEnabled = false;
            } else {
                this.uploadEnabled = this.uploadFileProperties.reduce((enabled, currentValue) => {
                    var ret = enabled && (
                        (
                            (this.accountDocuments && currentValue.accountId != undefined)
                            || (this.investorDocuments && currentValue.investorId != undefined)
                            || (this.advisoryFirmDocuments && currentValue.advisoryFirmId != undefined)
                            || this.accountDocumentAttachments || this.investorDocumentAttachments
                            || (this.operationsDataFiles == false || currentValue.externalSystemValue != null)
                        )
                        && (currentValue.documentTypeValue != null || currentValue.attachment)
                    ) || (
                            this.meetingDocuments
                        )

                    return ret;
                }, true)
            }
        }

        filesAdded(newFiles) {
            let investorId
            for (let file of newFiles) {
                var properties = new UploadFileProperties({ name: file.name, documentDate: file.lastModifiedDate, documentDescription: "", lastModified: file.lastModified, attachment: this.attachment, attachDocumentId: this.attachDocumentId, attachDocumentVersion: this.attachDocumentVersion, accountId: this.accountId, meetingId: this.meetingId, meetingGuid: this.meetingGuid, accountNumber: this.accountNumber, investorId: this.investorId, investorName: this.investorName, advisoryFirmId: this.advisoryFirmId, showUploadToCustodianCheckbox: this.showUploadToCustodianCheckbox, file });

                if (this.meetingDocuments) {
                    properties.documentTypeValue = this.meetingDocumentTypeValue;
                }
                this.uploadFileProperties.push(properties);
            }
            this.enableUploadButton();
        }

        fileSelectionChange($event) {
            this.filesAdded([].slice.call($event.target.files));
            //console.log("Event : " + $event);
        }

        fileUploadEventHandle(e, objXml: XMLHttpRequest, fileProperties: UploadFileProperties) {
            console.log(`File Upload Error: ${e.type}`, e);
            if (objXml.status >= 400) {
                toastr.error("Upload failed with status " + objXml.status + ". Message: " + objXml.responseText, "File Upload");
            }
        }

        fileUploadLoad(e, file: UploadFileProperties) {
            let index = this.uploadFileProperties.indexOf(file);
            if (index > -1) {
                this.uploadFileProperties.splice(index, 1);
                this.dgDocumentsToUpload.refresh(true);
            }

            if (this.uploadFileProperties.length == 0) {
                // all files are uploaded
                if (this.onAllFilesUploaded != undefined) {
                    this.onAllFilesUploaded();
                }
            }

            //console.log(`${e.type}`);
        }

        uploadFiles() {
            this.uploadEnabled = false;
            if (!this.attachment) {
                for (let fileProperty of this.uploadFileProperties) {

                    var data = new FormData();

                    data.append("file", fileProperty.formFieldValue("file"));
                    data.append("documentType", fileProperty.formFieldValue("documentTypeValue"));
                    data.append("documentDate", fileProperty.formFieldValue("documentDate"));
                    if (this.accountDocuments) {
                        data.append("accountId", fileProperty.formFieldValue("accountId"));
                        data.append("sendToCustodian", fileProperty.formFieldValue("sendToCustodian"));
                    }
                    if (this.investorDocuments || this.investorDocumentAttachments) {
                        data.append("investorId", fileProperty.formFieldValue("investorId"));
                    }
                    if (this.advisoryFirmDocuments) {
                        data.append("advisoryFirmId", fileProperty.formFieldValue("advisoryFirmId"));
                    }
                    if (this.operationsDataFiles) {
                        //console.log("EXTERNAL SYSTEM VALUE", fileProperty.formFieldValue("externalSystemValue"));
                        data.append("externalSystem", fileProperty.formFieldValue("externalSystemValue"));
                    }
                    if (this.meetingDocuments) {
                        data.append("meetingId", fileProperty.formFieldValue("meetingId"));
                        data.append("meetingGuid", fileProperty.formFieldValue("meetingGuid"));
                        data.append("documentDescription", fileProperty.formFieldValue("documentDescription"));
                    }

                    var objXhr = new XMLHttpRequest();

                    objXhr.upload.addEventListener("progress", function (event) {
                        fileProperty.fileUploadProgress(event);
                    });

                    objXhr.addEventListener("load", (e) => {
                        if (objXhr.readyState == XMLHttpRequest.DONE) {
                            if (objXhr.status >= 400) {
                                this.fileUploadEventHandle(e, objXhr, fileProperty);
                            }
                            else {
                                this.fileUploadLoad(e, fileProperty);
                            }
                        }
                        else {
                            //console.log("objXhr.readyState = ", objXhr.readyState)
                        }
                    });

                    // Add an event listener to handle the error event
                    objXhr.addEventListener("error", (e) => {
                        this.fileUploadEventHandle(e, objXhr, fileProperty);
                    });

                    //objXhr.addEventListener("loadend", function (event) {
                    //    if (this.loadEndEvent)
                    //        this.loadEndEvent();
                    //});

                    var url: string;
                    if (this.accountDocuments)
                        url = this.accountDocumentUploadUrl;
                    else if (this.investorDocuments)
                        url = this.investorDocumentUploadUrl;
                    else if (this.advisoryFirmDocuments)
                        url = this.advisoryFirmDocumentUploadUrl;
                    else if (this.operationsDataFiles)
                        url = this.operationsDataFileUploadUrl;
                    else if (this.meetingDocuments)
                        url = this.meetingFileUploadUrl;
                    else {
                        // should not reach this
                        return;
                    }

                    objXhr.open("post", url);
                    objXhr.send(data);
                    this.uploadEnabled = true;
                }
            } else {
                this.uploadingLadda = true;
                var data = new FormData();

                if (this.accountDocumentAttachments || this.investorDocumentAttachments) {
                    data.append("documentId", this.attachDocumentId.toString());
                    data.append("version", this.attachDocumentVersion.toString());
                }

                var objXhr = new XMLHttpRequest();
                var i: number = 0;
                for (let fileProperty of this.uploadFileProperties) {

                    data.append("file", fileProperty.formFieldValue("file"));
                    data.append("documentDate", fileProperty.formFieldValue("documentDate"));

                    if (this.accountDocumentAttachments && i == 0) {
                        data.append("accountId", fileProperty.formFieldValue("accountId"));
                    }
                    if (this.investorDocumentAttachments && i == 0) {
                        data.append("investorId", fileProperty.formFieldValue("investorId"));
                    }

                    objXhr.upload.addEventListener("progress", function (event) {
                        fileProperty.fileUploadProgress(event);
                    });
                    objXhr.addEventListener("load", (e) => {
                        if (objXhr.readyState == XMLHttpRequest.DONE) {
                            if (objXhr.status >= 400) {
                                this.fileUploadEventHandle(e, objXhr, fileProperty);
                            }
                            else {
                                this.fileUploadLoad(e, fileProperty);
                            }
                        }
                        else {
                            //console.log("objXhr.readyState = ", objXhr.readyState)
                        }
                    });
                    // Add an event listener to handle the error event
                    objXhr.addEventListener("error", (e) => {
                        this.fileUploadEventHandle(e, objXhr, fileProperty);
                    });

                    i = i + 1;
                }

                var url: string;
                if (this.accountDocumentAttachments)
                    url = this.accountAttachmentUploadUrl;
                else if (this.investorDocumentAttachments) {
                    // Current code should not reach here...
                    // Investor document attachments is not currently supported, could be added by adding this simple API
                    // modeled after the account attachment API.
                    //url = this.investorAttachmentUploadUrl;
                    toastr.error("You can not currently attach a document to an investor document.");
                    return;
                } else {
                    // should not reach this
                    return;
                }

                objXhr.open("post", url);

                objXhr.onreadystatechange = (aEvt) => {
                    if (objXhr.readyState == 4) {
                        if (objXhr.status == 200) {
                            var l: number = this.uploadFileProperties.length;
                            var s: string = this.uploadFileProperties.length > 1 ? " files" : " file";
                            this.uploadFileProperties.length = 0;
                            this.dgDocumentsToUpload.refresh(true);
                            toastr.success("Successfully attached " + l + s);
                        } else {
                            toastr.error(objXhr.responseText);
                        }
                        this.uploadEnabled = true;
                        this.uploadingLadda = false;
                        this.uploadButtonText = this.uploadButtonText;
                    }
                };
                objXhr.send(data);
            }
        }

        loadDocumentTypes(): void {
            this.documentTypes = [];
            //console.log("Loading document types .... Account ID:", this.accountId, " Investor:", this.investor, " Advisory Firm ID:", this.advisoryFirmId);
            this.generalService.getLOVs()
                .then(data => {
                    this.allDocumentTypes = data.filter(f => f.lovType == domains.LovType.DOCUMENT_TYPE);
                    if (this.meetingDocuments) {
                        this.documentTypes = this.allDocumentTypes.concat();
                    } else {
                        if (this.accountDocuments) {
                            // Currently filtering for signed document types only (24 May 2020, GL, opening up to unsigned)
                            if (this.allDocumentTypes && this.allDocumentTypes.length > 0)
                                //this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "1" && f.extra1 == "2")
                                this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "1")
                        } else if (this.investorDocuments) {
                            if (this.investor == undefined) {
                                this.documentTypes = this.allDocumentTypes.filter(f => (f.extra3 == "3" || f.extra3 == "3"));
                            } else if (this.investor.investorType == domains.InvestorType.INDIVIDUAL) {
                                this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "3");
                            } else if (this.investor.investorType == domains.InvestorType.COMPANY) {
                                this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "2");
                            }
                        } else if (this.advisoryFirmDocuments) {
                            this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "4");
                        } else if (this.operationsDataFiles) {
                            this.documentTypes = this.allDocumentTypes.filter(f => f.extra3 == "5");
                        }
                    }
                    // Sort document types list by document type name
                    if (this.documentTypes && this.documentTypes.length > 0) {
                        this.documentTypes = this.documentTypes.sort(function (a, b) { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
                    }
                    if (this.dgDocumentsToUpload) {
                        this.dgDocumentsToUpload.columnOption("Document Type",
                            {
                                lookup: {
                                    dataSource: this.documentTypes,
                                    valueExpr: "value",
                                    displayExpr: "name"
                                },
                                customizeText: (e) => {
                                    if (e.value == null) {
                                        return "select a document type...";
                                    }
                                    return e.value;
                                }
                            });
                    }
                });
        }

        loadBackOfficeSystems() {
            this.generalService.getExternalSystemsByType(domains.ExternalSystemType.BACK_OFFICE).then(data => {
                //console.log(data.data);
                if (data.data)
                    this.externalSystems = data.data;

                this.generalService.getExternalSystemsByType(domains.ExternalSystemType.CUSTODIAN).then(data => {
                    if (data.data)
                        this.externalSystems = [...this.externalSystems, ...data.data];

                    this.dgDocumentsToUpload.columnOption("External System",
                        {
                            lookup: {
                                dataSource: this.externalSystems,
                                valueExpr: "id",
                                displayExpr: "name"
                            },
                            customizeText: (e) => {
                                if (e.value == null) {
                                    return "select source system...";
                                }
                                return e.value;
                            }
                        });
                });
            });
        }

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }   
            for (var key in evt) {
                if ((key == "accountId" && this.accountId > 0) ||
                    (key == "investor" && this.investor && this.investor.id > 0) ||
                    (key == "accountDocuments" && this.accountDocuments) ||
                    (key == "investorDocuments" && this.investorDocuments) ||
                    (key == "advisoryFirmId" && this.advisoryFirmId > 0) ||
                    (key == "advisoryFirmDocuments" && this.advisoryFirmDocuments) ||
                    (key == "attachment" && this.attachment) ||
                    (key == "attachDocumentId" && this.attachDocumentId) ||
                    (key == "attachDocumentVersion" && this.attachDocumentVersion) ||
                    (key == "operationsDataFiles" && this.operationsDataFiles)) {
                    this.accountDocuments = this.accountDocuments || (key == "accountId" && this.accountId > 0 && !this.attachment);
                    this.investorDocuments = this.investorDocuments || (key == "investor" && this.investor && this.investor.id > 0 && !this.attachment);
                    this.advisoryFirmDocuments = this.advisoryFirmDocuments || (key == "advisoryFirmId" && this.advisoryFirmId > 0 && !this.attachment);
                    this.accountDocumentAttachments = (key == "attachment" || key == "attachDocumentId" || key == "attachDocumentVersion" || key == "accountId") && this.accountId > 0 && this.attachment && this.attachDocumentId != undefined && this.attachDocumentVersion != undefined;
                    this.investorDocumentAttachments = (key == "attachment" || key == "attachDocumentId" || key == "attachDocumentVersion" || key == "investor") && this.investor && this.investor.id > 0 && this.attachment && this.attachDocumentId != undefined && this.attachDocumentVersion != undefined;
                    this.searchTitle = this.accountDocuments ? "Account Search x" : "Investor Search";
                    //console.log("accountDocumentAttachments", this.accountDocumentAttachments);
                    //console.log("key", key);
                    //console.log("other stuff", this.accountId, this.attachment, this.attachDocumentId, this.attachDocumentVersion);
                    this.loadDocumentTypes();
                    // external systems only needed when loading operations data files
                    if (this.operationsDataFiles)
                        this.loadBackOfficeSystems();
                } else if (key == "showUploadToCustodianCheckbox") {
                    this.showUploadToCustodianCheckbox = evt.showUploadToCustodianCheckbox.currentValue;
                } else if (key == "meetingDocuments") {
                    this.loadDocumentTypes();
                }
            }
            if (this.investor && this.investor.id > 0) {
                this.investorId = this.investor.id;
                this.investorName = (this.investor.investorType == domains.InvestorType.INDIVIDUAL ? this.investor.fullName : this.investor.entityName) + "(" + this.investor.tin + ")";
            }
            this.setupColumns();
        }
    }

    class FileUploader implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                attachment: "<",
                attachDocumentId: "<",
                attachDocumentVersion: "<",
                accountId: "<",
                accountNumber: "<",
                accountDocuments: "<",
                investor: "<",
                investorDocuments: "<",
                advisoryFirmId: "<",
                //advisoryFirmDocuments: "<",
                showUploadToCustodianCheckbox: "<",
                operationsDataFiles: "<",
                meetingId: "<",
                meetingGuid: "<",
                meetingDocuments: "<",
                onAllFilesUploaded: "&",
                loadEndEvent: "&"
            };
            this.controller = FileUploaderController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/file-uploader.html";
        }

    }
    angular.module(Constants.APP).component("fileUploader", new FileUploader());
}
